/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */

import { node, NODE_TYPE, Fragment as BaseFragment } from "jsx-pragmatic";
// import { $ } from 'venuescanner-js/tools/elemental'
import styleParser from "./styleParse";
import debounce from "debounce";
import { ObservableArray } from "venuescanner-js/vanilla/models/ObservableArray";
import { ObservableObject } from "venuescanner-js/vanilla/models/ObservableObject";
import {
  STRING,
  BOOLEAN,
} from "venuescanner-js/vanilla/models/ObservablePropTypes";

const removeScriptTags = false;
const stripWebpackObjectFromFunction = (str) => {
  if (typeof str === "function") str = str.toString();
  // Return function as string, with webpack children removed
  const regexes = [
    /(.*Object\([^\)]*)(\([^\)]*\))([^\)]*\).*)/,
    /(.*Object\([^\)]*\)\(.*)(\([^\)]*\))([^\)]*\).*)/,
    /(.*Object\([^\)]*\))(\([^\)]*\))(.*)/,
    /(.*)(Object\([^\)]*\))(.*)/,
  ];
  let stripped = `${str}`;
  let stripped2 = null;
  while (regexes.length) {
    const subBraces = regexes.shift();
    let checks = 0;
    while (checks === 0 || stripped2 != stripped) {
      if (stripped2 !== null) stripped = stripped2;
      stripped2 = stripped.replace(subBraces, "$1$3");
      checks++;
    }
  }
  return stripped2;
};
const propsNotDirect = ["class"];
const propsIsObservable = (el, key, val) => {
  try {
    let toSet =
      val && val.stencilProp
        ? val.stencilProp()
        : val && val.valueOf
        ? val.valueOf()
        : val;
    // const directProp = (val.stencilProp || toSet instanceof Object || toSet instanceof Array || val.valueOf || val===null)
    const directProp =
      !propsNotDirect.includes(key) &&
      typeof val !== "string" &&
      !(val instanceof STRING);
    // if (key === 'chosen_sub_plan') {
    //   console.log(typeof toSet, toSet, { directProp })
    // }
    // let toSet = val.stencilProp ? val.stencilProp() : val
    // directProp = (toSet instanceof Object || toSet instanceof Array)
    const propKey = directProp
      ? key.replace(/(\-[a-z])/g, (m) => m.replace(/\-/g, "").toUpperCase())
      : key;
    if (val && typeof val.watch === "function") {
      // console.log(!propsNotDirect.includes(key), directProp, key, toSet)
      val.watch((toSet) => {
        // console.log(toSet)
        // console.log(val && val.stencilProp ? val.stencilProp() : (val.valueOf ? val.valueOf() : val))
        if (!toSet)
          toSet =
            val && val.stencilProp
              ? val.stencilProp()
              : val && val.valueOf
              ? val.valueOf()
              : val;
        if (toSet === null && !directProp) toSet = "";
        directProp
          ? (el[propKey] = toSet)
          : el.setAttributeNS(null, propKey, toSet);

        // console.log(val && val.stencilProp ? val.stencilProp() : val)
        // directProp
        // ? el[propKey] =  val && val.stencilProp ? val.stencilProp() : val
        // :el.setAttributeNS(null, propKey,  val && val.stencilProp ? val.stencilProp() : val)
      }, false);
    }
    // if (val.stencilProp) {
    //   console.log({el, val, directProp})
    // }
    // console.log({ key,toSet })
    // if (key === 'value') console.log(directProp, key,toSet, val)
    // if (!directProp && propKey === 'value') console.log(toSet)
    if (toSet === null && !directProp) toSet = "";
    directProp
      ? (el[propKey] = toSet)
      : el.setAttributeNS(null, propKey, toSet);
  } catch (e) {
    // console.log({el, key, val})
    console.error(e);
  }
};
const propsObservable = (props, deepUses = []) => {
  // if (deepUses.length) console.log(deepUses,Object.keys(props))
  return [
    ...new Set(
      deepUses
        .map((keys) => {
          let baseProp = props[keys.shift()];
          while (
            baseProp &&
            baseProp.observable !== "PropType" &&
            keys.length
          ) {
            const key = keys.shift();
            if (baseProp instanceof ObservableArray) {
              keys = [];
              // }else if (
              // if (arrayFound && typeof arrayFound[key] === 'function') {
              //   keys = []
            } else {
              baseProp = baseProp[key];
            }
          }
          // if (baseProp) console.log({ baseProp })
          return baseProp &&
            (baseProp instanceof ObservableObject ||
              baseProp instanceof ObservableArray ||
              baseProp.observable === "PropType")
            ? baseProp
            : null;
        })
        .filter((r) => r !== null)
    ),
  ];
};
const funcContainsWatchMessage = (f) => {
  // if (f.match(/jsxconsole/)) console.log(f)
  const toCheck = f.match(/watch=\(([^\)]*)/);
  // const toCheck = f.match(/@watch="\.concat\(Object\([^\)]*\)\(([^\)]*)\)\)/)
  // const toCheck = f.match(/@watch="\.concat\(Object\([^\)]*\)\(([^\)]*)\)\)/)
  // console.log(toCheck)
  // if (toCheck && toCheck.length>1) {
  //   const list = toCheck[0].match(/\(([^\)]*)\)\);$/)
  const watchVars =
    toCheck && toCheck.length > 1
      ? toCheck[1]
          .split(",")
          .map((v) => v.trim())
          .filter((w) => w !== "")
      : [];
  // }
  // if (f.match(/@watch=/)) {
  //   // console.log(f)
  //   const toCheck = f.match(/@watch=[^;]*;/)
  //   console.log(toCheck, toCheck[0])
  //   if (toCheck && toCheck[0]) {
  //     const list = toCheck[0].match(/\(([^\)]*)\)\);$/)
  //     const watchVars = list.length>1 ? list[1].split(',').map(v => v.trim()) : []
  //     console.log(watchVars)
  //   }
  //   const watchVars = [...f.matchAll(/jsxWatch"\]\)\((.*?)\)/gi)].map(m => m[1].split(',').map(w => w.trim())).flat().filter(w => w !== '')
  // }
  // if (f.match(/jsxWatch"\]\)\(/i)) {
  //   const watchVars = [...f.matchAll(/jsxWatch"\]\)\((.*?)\)/gi)].map(m => m[1].split(',').map(w => w.trim())).flat().filter(w => w !== '')
  // console.log({watchVars})
  if (watchVars.length) {
    // console.log(watchVars)
    return watchVars.map((w) => w.split("."));
  } else {
    return [];
  }
  // } else {
  //   return false
  // }
};
const functionHasObservable = (f, props) => {
  if (f instanceof Function) {
    let str = stripWebpackObjectFromFunction(f);
    let deepUses = funcContainsWatchMessage(f.toString());
    // if (props.selectedTag) console.log(f,JSON.stringify(deepUses, 2, null))

    // if (props.show && deepUses) console.log(JSON.stringify(deepUses, null, 2))

    if (!deepUses) {
      const found = Object.keys(props);
      str = str.replace(/\{var [^;]*;/, "");
      found.forEach((varName) => {
        str = str.replace(new RegExp(`${varName}=_ref\.${varName}`), "");
      });
      const uses = [
        ...str.matchAll(new RegExp(`(.${found.join("|.")})\\b`, "g")),
      ]
        .map((arr) => (arr.length && arr.length > 1 ? arr[1] : null))
        .filter((r) => r !== null)
        .filter((r) => !r.match(/^[\.a-z]/i))
        .map((r) => r.replace(/^./, ""));
      const posObvs = [...new Set(uses)];
      deepUses = [
        ...str.matchAll(new RegExp(`(.${posObvs.join("|.")}[a-zA-Z\.]*)`, "g")),
      ]
        .map((arr) => (arr.length && arr.length > 1 ? arr[1] : null))
        .filter((r) => r !== null)
        .filter((r) => !r.match(/^[\.a-z]/i))
        .map((r) => r.replace(/^./, "").split("."));
    }
    // console.log(deepUses)
    const obvs = propsObservable(props, deepUses);
    // if (obvs.length === 1 && obvs[0].getKey() === 'monday') {
    //   console.log(obvs)
    //   console.log(deepUses)
    //   console.log(stripWebpackObjectFromFunction(f))
    // }
    return obvs;
  }
  return false;
};
const propsWatchingRender = (propsTowatch = [], render, showInConsole) => {
  // console.log(propsTowatch)
  const bouncing = debounce(render);
  propsTowatch.forEach((prop) => {
    if (prop && typeof prop.watch === "function") prop.watch(bouncing, false);
  });
};
const applyStyle = (el, css) => {
  Object.keys(css).forEach((key) => {
    if (css[key] && typeof css[key].watch === "function") {
      css[key].watch(() => {
        el.style[key] = styleParser[key]
          ? styleParser[key](css[key])
          : css[key].valueOf
          ? css[key].valueOf()
          : css[key];
      }, false);
    }
    el.style[key] = styleParser[key]
      ? styleParser[key](css[key])
      : css[key].valueOf
      ? css[key].valueOf()
      : css[key];
  });
};
// const ElementCollection = function(elements=[]) {
//   elements = elements instanceof Array ? elements : [elements]
//   this.assign = function(elements=[]) {
//     elements = elements instanceof Array ? elements : [elements]
//     elements.forEach(element => {
//       if (!element.elementCollection) element.elementCollection = []
//       if (!element.elementCollection.includes(this)) element.elementCollection.push(this)
//     })
//     return elements
//   }
//   this.set = function(elements=[]) {
//     elements = elements instanceof Array ? elements : [elements]
//     this.elements = this.assign([...elements])
//   }
//   this.swap = function({oldElements=[],newElements=[]}) {
//     newElements = this.assign(newElements)
//     while(oldElements.length) {
//       const el = oldElements.shift()
//       let idx = this.elements.indexOf(el)
//       while (idx>=0) {
//         this.elements.splice(idx,1)
//         idx = this.elements.indexOf(el)
//       }
//     }
//     while(newElements.length) {
//       const el = newElements.shift()
//       if (!this.elements.includes(el)) this.elements.push(el)
//     }
//     console.log(this.elements)
//   }
//   this.elements = this.assign([...elements])
// }
const domRenderer = (node) => {
  try {
    if (node.type === NODE_TYPE.COMPONENT) {
      if (node.props && !["InputComponent"].includes(node.component.name)) {
        const listening = (el) => {
          for (const [key, val] of Object.entries(node.props)) {
            // if (val.watch) console.log({ [key]: val.constructorName })
            if (key.match(/^on/)) {
              let event = key.replace(/^on/, "").split("");
              event[0] = event[0].toLowerCase();
              event = event.map((c) => {
                if (c === c.toUpperCase()) c = `-${c.toLowerCase()}`;
                return c;
              });
              el.addEventListener(event.join(""), val);
              // console.log(val)
            } else if (key === "ref") {
              if (val instanceof Array && val.length === 2) {
                val[0][val[1]] = el;
              } else if (val instanceof Function) {
                val(el);
              }
            }
          }
        };
        // console.log(node.component)
        const obvs = functionHasObservable(node.component, node.props);
        const otherListeners = Object.keys(node.props).filter((key) => {
          return key === "ref" || key.match(/^on/);
        });
        // if (node.props.selectedNetwork) console.log({ selectedNetwork: obvs })
        // if (node.props.chosen_sub_plan) console.log(obvs)
        if (obvs.length || otherListeners.length) {
          // found observable props in expression
          let element = node.renderComponent(domRenderer);
          // if(!(element instanceof Array)) element = [element]
          // element = element.filter(e => e)
          // console.log(element)
          if (!element) element = document.createComment("");
          // console.log(element)
          // const elementCollection = new ElementCollection([...element])
          const render = () => {
            try {
              // const element = [...elementCollection.elements]
              let newElement = node.renderComponent(domRenderer);
              // console.log(newElement)
              // console.log({element,newElement})
              // if(!(newElement instanceof Array)) newElement = [newElement]
              // if (newElement.length>1) {
              //   console.log({
              //     newElement:[...newElement],
              //     element:[...element]
              //   })
              // }
              newElement = newElement || document.createComment("");
              // allCollections.forEach(collection => {
              //   collection.swap({
              //     oldElements:[...element],
              //     newElements:[...newElement]
              //   })
              // })
              if (element.replaceWith) {
                element.replaceWith(newElement);
              } else if (element.parentElement) {
                element.parentElement.insertBefore(newElement, element);
                element.parentElement.removeChild(element);
              }

              element = newElement;
              // if (element.length === 1 && newElement.length === 1) {
              //   element[0].replaceWith(newElement[0])
              //   // element = newElement
              // }else{
              //   const firstElement = element[0]
              //  if (!firstElement) console.log(node)
              //   while(newElement.length) {
              //     if (firstElement.parentElement) firstElement.parentElement.insertBefore(newElement.shift(), firstElement)
              //   }
              //   while(element.length) {
              //     const toRemove = element.pop()
              //     console.log({toRemove})
              //     if (toRemove.parentElement) toRemove.parentElement.removeChild(toRemove)
              //   }
              //   // element = recordElements
              // }
              // elementCollection.set(element)
              listening(newElement);
              // console.log({element})
            } catch (e) {
              console.error(e);
            }
          };
          listening(element);

          // const container = document.createElement('jsxobservable')
          // container.obvs = obvs
          // const render = () => {
          //   container.style.height = `${container.getBoundingClientRect().height}px`
          //   $(container).empty().append(node.renderComponent(domRenderer))
          //   delete container.style.height
          // }
          // if (element.tagName==='VS-BTN') console.log(obvs)
          // console.log(element.tagName)
          // if (node.props.selectedTag) console.log(obvs.length, element.componentOnReady)
          if (!element.componentOnReady) {
            if (obvs.length) propsWatchingRender(obvs, render, false);
            // console.log(obvs)
          }
          return element;
        }
      }
      return node.renderComponent(domRenderer);
    }
    // console.log(node.type,Object.keys(node.props))
    // if (key === 'value') console.log(key,node.name, val)
    if (node.type === NODE_TYPE.TEXT) {
      return document.createTextNode(node.text);
    }

    if (node.type === NODE_TYPE.ELEMENT) {
      if (removeScriptTags && node.name === "script") {
        return;
      }
      const el = document.createElement(node.name);
      try {
        let hasARef = false;
        for (const [key, val] of Object.entries(node.props)) {
          // if (val.watch) console.log({ [key]: val.constructorName })
          if (key.match(/^on/)) {
            let event = key.replace(/^on/, "").split("");
            event[0] = event[0].toLowerCase();
            event = event.map((c) => {
              if (c === c.toUpperCase()) c = `-${c.toLowerCase()}`;
              return c;
            });
            el.addEventListener(event.join(""), val);
            // console.log(val)
          } else {
            if (key === "ref") {
              hasARef = true;
              if (val instanceof Array && val.length === 2) {
                val[0][val[1]] = el;
              } else if (val instanceof Function) {
                val(el);
              }
            } else if (key === "style") {
              applyStyle(el, val);
            } else {
              // if (key === 'from') {
              //   console.log(key,val, el)
              //   console.log({array:val instanceof Array})
              //   console.log({Number:val instanceof Number})
              //   console.log({Function:val instanceof Function})
              //   console.log({notequal:typeof val !== 'object' && 1*val === val})
              //   console.log({null:val === null})
              // }
              try {
                if (
                  val instanceof Array ||
                  val instanceof Number ||
                  val instanceof Function ||
                  (typeof val !== "object" && 1 * val === val) ||
                  val === null
                ) {
                  // console.log(el)
                  // console.log(JSON.stringify({val:val}))
                  el[key] = val;
                } else {
                  // console.log(el)
                  // if (key === 'value') console.log(key,node.name, val)
                  // if (val.getKey && val.getKey() === 'hour') console.log(key, val)
                  propsIsObservable(el, key, val);
                  // el.setAttributeNS(null, key, val)
                }
              } catch (e) {
                console.error(e);
              }
            }
          }
        }
        // if (hasARef) {
        //   el.update = () => {
        //     el.innerHTML = ''
        //     for (let child of node.children) {
        //       el.appendChild(child.render(domRenderer))
        //     }
        //   }
        // }
        for (const child of node.children) {
          try {
            const toAppend = child.render(domRenderer);
            if (toAppend instanceof Array) {
              while (toAppend.length) {
                const kid = toAppend.shift();
                if (kid) el.appendChild(kid);
              }
            } else if (toAppend) {
              el.appendChild(toAppend);
            }
          } catch (e) {
            console.log(el);
            console.error(e);
            // console.log(child)
          }
        }
      } catch (e) {
        console.error(e.message, el);
      }
      // console.log(el)
      return el;
    }
  } catch (e) {
    console.log(node);
    console.error(e);
  }
};
const RenderComponent = ({ value }) => {
  if (value.render) {
    return {
      type: NODE_TYPE.ELEMENT,
      render: () => {
        return value.render();
      },
    };
  }
  return <span>Invalid object to render</span>;
};
const InputComponent = ({ value }) => {
  if (value.input) {
    return {
      type: NODE_TYPE.ELEMENT,
      dontObserve: true,
      render: () => {
        return value.input();
      },
    };
  }
  return <span>Invalid object to render</span>;
};
const Comment = ({ text = "", ref }) => {
  return {
    type: NODE_TYPE.ELEMENT,
    dontObserve: true,
    render: () => {
      const node = document.createComment(text);
      if (ref) ref(node);
      return node;
    },
  };
};
const Html = ({ text = ",", ref }) => {
  return {
    type: NODE_TYPE.ELEMENT,
    dontObserve: true,
    render: () => {
      const node = document.createElement("span");
      if (ref) ref(node);
      node.innerHTML = text;
      return [...node.childNodes];
    },
  };
};
const HtmlElement = ({ element = null, ref }) => {
  return {
    type: NODE_TYPE.ELEMENT,
    dontObserve: true,
    render: () => {
      return [element];
    },
  };
};
const Fragment = (props = {}, children = []) => {
  return {
    type: NODE_TYPE.ELEMENT,
    dontObserve: true,
    render: (renderer) => {
      const el = document.createElement("fragment");

      for (const child of children) {
        try {
          const toAppend = child.render(renderer);
          if (toAppend instanceof Array) {
            while (toAppend.length) {
              el.appendChild(toAppend.shift());
            }
          } else {
            el.appendChild(toAppend);
          }
        } catch (e) {
          console.error(e);
          // console.log(child)
        }
      }
      return el;
    },
  };
};
const jsxWatch = (declarator) => {
  if (!declarator)
    throw new Error(
      "Watching declarator string is not defined, should be 'watch=()"
    );
  if (!declarator.match(/watch=\([^\)]*\)/))
    throw new Error(
      `${declarator} is not the valid format, should be 'watch=(observable,observable...)`
    );
  // declarator for params to watch
  return "";
};

const observableMethod = (observables, method) => {
  let observable = observables instanceof Array ? observables : [observables];
  observable = observable.filter((obs) => !!obs.watch);
  if (!observable.length)
    throw new Error("observableMethod did not receive observables");
  return {
    watch: (response) => {
      observable.forEach((obs) => {
        obs.watch(() => {
          response(method());
        });
      });
    },
    valueOf: () => {
      return method();
    },
  };
};
const ComponentWrapper = ({ observe }, children = []) => {
  jsxWatch(observe);
  // This is not React, it's just JSX, React rules don't apply
  // eslint-disable-next-line react/no-unknown-property
  return observe.valueOf() ? (
    <BaseFragment>{children}</BaseFragment>
  ) : (
    <span class="loading"></span>
  );
};
const CallbackComponent = ({ callbackCreator, component }) => {
  const called = new BOOLEAN(null, false);
  callbackCreator(() => {
    // console.log("loaded")
    called.set(true);
  });
  return {
    type: NODE_TYPE.ELEMENT,
    dontObserve: true,
    render: (renderer) => {
      return (
        <ComponentWrapper observe={called}>{component}</ComponentWrapper>
      ).render(renderer);
    },
  };
};
export {
  node,
  domRenderer,
  RenderComponent,
  InputComponent,
  Fragment,
  Comment,
  Html,
  HtmlElement,
  jsxWatch,
  observableMethod,
  CallbackComponent,
};
